import { DefaultChannelVolume, EventType } from '../slices/local/orchestrator';
import { type Channel } from '../slices/local/user';

export const transformTmsCubeDataToChannels = (cube: any): Record<number, Channel> => {
  const channels: Record<number, Channel> = {};

  if(typeof(cube.songs) !== 'undefined') {
    Object.entries(cube.songs as Record<string, unknown>)
    .filter(([key]) => key.match(/^output_\d+$/))
    .forEach(([key, song]: [string, any]) => {
      const matches = key.match(/^output_(\d+)$/);
      if (matches !== null) {
        const channel = parseInt(matches[1]);

        if (channels[channel] === undefined) {
          channels[channel] = {
            channel,
            volume: DefaultChannelVolume,
            cubeEvents: []
          };
        }

        channels[channel].cubeEvents?.push({
          type: EventType.Started,
          when: +new Date(),
          ref: 1,
          song: {
            artist: song.artist,
            duration: 0,
            persistentId: song.persistent_id,
            title: song.name,
            genre: '',
            songId: 0
          }
        });
      }
    });
  }

  if(typeof(cube.last_played) !== 'undefined') {
    Object.entries(cube.last_played as Record<string, unknown>)
    .filter(([key]) => key.match(/^\d+$/))
    .forEach(([key, songs]: [string, any]) => {
      const matches = key.match(/^(\d+)$/);
      if (matches !== null) {
        const channel = parseInt(matches[1]);

        if (channels[channel] === undefined) {
          channels[channel] = {
            channel,
            volume: DefaultChannelVolume,
            cubeEvents: []
          };
        }

        (songs as any[]).forEach(song => {
          channels[channel].cubeEvents?.push({
            type: EventType.Started,
            when: +new Date(song.play_time),
            ref: 0,
            song: {
              artist: song.artist,
              duration: 0,
              persistentId: song.persistent_id,
              title: song.name,
              genre: '',
              songId: song.id
            }
          });
        });
      }
    });
  }

  Object.entries(cube.config as Record<string, unknown>)
  .filter(([key]) => key.match(/^output_\d+?_.*$/))
  .forEach(([key, value]) => {
    const matches = key.match(/^output_(\d+?)_(.*)$/);
    if (matches !== null) {
      const channel = parseInt(matches[1]);
      const name = matches[2];
      if (channels[channel] === undefined) {
        channels[channel] = {
          channel,
          volume: DefaultChannelVolume
        };
      }

      switch (name) {
        case 'name':
          channels[channel].name = value as string;
          break;
        case 'station_id':
          channels[channel].stationId = parseInt(value as string);
          break;
        case 'volume':
          channels[channel].volume = parseInt(value as string);
          break;
      }
    }
  });

  return channels;
}
